export const getPastaPromotora = (idpromotora) => {
    const pastas = {
        '12': 'gl',
        '68': 'bts',
        '67': 'malinovski',
        '73': 'aiba'
    };
    return pastas[idpromotora];
}